<div class="govuk-grid-row">
    <div class="govuk-grid-column-full">
        <h1 class="govuk-heading-xl"> {{pageTitle}}</h1>
    </div>
</div>

<ng-container *ngIf="selectedDepartment">
    <app-mat-calendar [service]="selectedService" [location]="selectedLocation" [component]="component" class="row">
    </app-mat-calendar> 

    <br />
    <br />
    <div class="govuk-button-group">
        <button type="submit" class="govuk-button govuk-button--secondary" data-module="govuk-button"
            (click)="routerGoBack()">{{'COMMON.BACK' | translate}}
        </button>
        <button *ngIf="selectedDepartment" type="submit" class="govuk-button" data-module="govuk-button"
            (click)="continue()">{{'COMMON.NEXT' |
            translate}}
        </button>
    </div>
</ng-container>